import {
  Content,
  Score
} from "seneca-common/features/module/module-types/worked-example/types";

import { AttemptingState } from "./types";

export const actionTypes = {
  setAttempting: "setAttempting",
  incrementCurrentStepIndex: "incrementCurrentStepIndex",
  markNextAppropriateWordAsSkipped: "markNextAppropriateWordAsSkipped"
};

type ActionT<
  typeT extends keyof typeof actionTypes,
  PayloadT extends Record<string, any> | void = void
> = {
  type: typeT;
  payload: PayloadT;
};

// @ts-ignore
type SetAttempting = ActionT<"setAttempting", AttemptingState | null>;

export function setAttempting(
  attemptingState: AttemptingState | null = null
): SetAttempting {
  return {
    // @ts-ignore
    type: actionTypes.setAttempting,
    payload: attemptingState
  };
}

type IncrementCurrentStepIndex = ActionT<
  "incrementCurrentStepIndex",
  {
    content: Content;
  }
>;

export function incrementCurrentStepIndex(
  content: Content
): IncrementCurrentStepIndex {
  return {
    // @ts-ignore
    type: actionTypes.incrementCurrentStepIndex,
    payload: {
      content
    }
  };
}

type MarkNextAppropriateWordAsSkipped = ActionT<
  "markNextAppropriateWordAsSkipped",
  {
    score: Score;
    content: Content;
  }
>;

export function markNextAppropriateWordAsSkipped(
  score: Score,
  content: Content
): MarkNextAppropriateWordAsSkipped {
  return {
    // @ts-ignore
    type: actionTypes.markNextAppropriateWordAsSkipped,
    payload: {
      score,
      content
    }
  };
}

export type Actions =
  | SetAttempting
  | IncrementCurrentStepIndex
  | MarkNextAppropriateWordAsSkipped;
